import React from "react"
import _ from "../../utils/lodashUtils"
import {
  NOTIFY_BUTTON,
  PARTNER_AWAY,
  CALL_PARTNER_BACK,
  DEFAULT_SPACE_NAME,
} from "../../constants/messages"
import "./PartnerAway.scss"
import { Button, Banner, TextTag as Text } from "../../atoms"
import {
  FirebaseService,
  FIREBASE_STATE_KEYS,
  FirebaseContext,
} from "../../firebase"
import { getPartnerNameorNickName, getNudgeState } from "../../utils/helpers"

const PartnerAway = props => {
  //Banner when partner is offline
  let gender = ""
  const { invitePartnerToChat } = props
  const { partnerState, dateState, userState } = React.useContext(
    FirebaseContext
  )
  const partnerOnline = _.get(partnerState, "presence.isOnline", false)
  const partnerName = getPartnerNameorNickName(partnerState)
  const partnerGender = _.get(partnerState, "userDetails.gender")
  const chatSpaceName = _.get(dateState, "chatSpaceName", DEFAULT_SPACE_NAME)
  const activeScreen = _.get(userState, FIREBASE_STATE_KEYS.ACTIVE_SCREEN)
  const partnerActiveScreen = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.ACTIVE_SCREEN
  )

  const notifyBack = () => {
    const nudgeState = getNudgeState(activeScreen)
    if (partnerOnline) {
      FirebaseService.notifyPartnerBack({ chatSpaceName, partnerActiveScreen })
    } else {
      invitePartnerToChat(partnerName, nudgeState)
    }
  }
  function findPartner() {
    gender =
      partnerGender === "MALE"
        ? " he"
        : partnerGender === "FEMALE"
        ? " she"
        : " they"
  }
  let pronoun = ""
  function findPartnerPronoun() {
    pronoun = gender === " he" ? "him" : gender === " she" ? "her" : "them"
  }
  findPartner()
  findPartnerPronoun()
  return partnerName ? (
    <Banner type="secondary">
      <div className="nudge-banner-container">
        <div className="flex-col">
          <div className="center">
            <Text textType="sectionHeading" className="banner-text">
              {PARTNER_AWAY(partnerName)}
            </Text>
          </div>
          <div className="subhead center">
            <Text textType="sectionTextPrimary" className="banner-text">
              {CALL_PARTNER_BACK(gender)}
            </Text>
          </div>
        </div>
        <Button type="primary" className="notify-button" onClick={notifyBack}>
          {NOTIFY_BUTTON(pronoun)}
        </Button>
      </div>
    </Banner>
  ) : null
}

export default PartnerAway
